import { useEffect, useRef, useState } from "react";

// Hook chiquito para el portal de inicio: agrega la clase "visible" a un
// elemento la primera vez que entra en la pantalla al hacer scroll (efecto
// de aparecer suavemente), usando la clase .revelar/.revelar.visible de
// index.css. Sin dependencias externas.
export function useRevelarAlEntrar<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entrada]) => {
        if (entrada.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return { ref, visible };
}
